import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

import { environment } from '../../../environments/environment';
import { KudosService } from '../../services/kudos.service';
import { VersionService } from '../../services/version.service';
import { KudosDialogComponent } from '../kudos-dialog/kudos-dialog';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatButtonModule, TranslocoPipe],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
})
export class AppFooterComponent {
  currentYear = new Date().getFullYear();
  versionInfo = inject(VersionService).getVersionInfo();
  hasKudos = inject(KudosService).hasKudos;
  executionMode = environment.executionMode;

  private readonly dialog = inject(MatDialog);
  private readonly versionService = inject(VersionService);

  get semanticVersion(): string {
    return this.versionInfo.version.semantic;
  }

  get commitHash(): string {
    return this.versionInfo.version.commit;
  }

  get dockerTag(): string {
    return this.versionInfo.version.dockerTag;
  }

  get platformVersion(): string {
    return this.versionInfo.version.platform;
  }

  get buildInfo(): string {
    return this.versionService.getBuildInfo();
  }

  openKudosDialog(): void {
    this.dialog.open(KudosDialogComponent, {
      width: '500px',
      maxWidth: '90vw',
      panelClass: 'kudos-dialog-panel',
    });
  }
}
